import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  Alert,
  Avatar,
  Button,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router";
import {
  KinshipPetProfile,
  OwnersProfileExtras,
} from "../../utils/kinshipTypes";
import { MedicalRecordView } from "../pet-medical-records/MedicalRecordView";
import { deletePetProfile, getPetProfile } from "../../utils/back4AppApi";
import { translate } from "../../utils/localisation";
import { getProfileByOwnerKinshipId } from "../../utils/kinshipApi";

export function PetProfileEdit() {
  const navigate = useNavigate();
  const [currentLocale, setCurrentLocale] = useState("");
  const [ownersProfileExtras, setOwnersProfileExtras] =
    useState<OwnersProfileExtras>({});
  const [ownersProfile, setOwnersProfile] = useState<any>({});
  const [pet, setPet] = useState<KinshipPetProfile>();

  const { petId } = useParams();

  const fetchPetDetails = useCallback(async () => {
    console.log("fetchPetDetails -> starting () -> petId =>", petId);
    const extraData = await getPetProfile(petId);
    console.log("extraData =>", extraData?.data);
    console.log(
      "ownerEmail =>",
      extraData?.data?.ownerships[0]?.ownerEmail || ""
    );
    console.log(
      "ownerKinshipId =>",
      extraData?.data?.ownerships[0]?.ownerKinshipId || ""
    );
    const ownersProfile = await getProfileByOwnerKinshipId(
      extraData?.data?.ownerships[0]?.ownerKinshipId || ""
    );
    if (ownersProfile?.data) {
      console.log("ownersProfile =>", ownersProfile);
      console.log("ownersLocale =>", ownersProfile?.data?.locale);
      localStorage.setItem(
        "ownersLocale",
        JSON.stringify(ownersProfile?.data?.locale)
      );
      setCurrentLocale(ownersProfile?.data?.locale);

      if (extraData?.data) {
        extraData.data.ownersProfileExtras = {
          divisions: ownersProfile?.data.divisions,
        };
        console.log(
          "practiceGroup->divisions =>",
          ownersProfile?.data.divisions
        );
        setOwnersProfileExtras(extraData.data.ownersProfileExtras);
      }

      if (extraData?.data) {
        extraData.data.ownershipLocale = ownersProfile?.data?.locale;
        console.log("pet =>", extraData.data);
      }

      extraData.data.ownersProfile = ownersProfile?.data;
      setOwnersProfile(ownersProfile?.data);
    }
    setPet(extraData.data);
  }, [petId]);

  useEffect(() => {
    fetchPetDetails();
    console.log("mounted -> fetchPetDetails -> called => ()");
  }, [fetchPetDetails]);

  const handleClick = (
    event: React.MouseEvent<unknown>,
    key: string,
    value: string
  ) => {
    // navigate to route component PetProfile of the petId
    switch (key) {
      case "pack_subscription_id":
        window.location.href = `https://dashboard.stripe.com/test/subscriptions/${value}`;
        break;
      default:
        break;
    }
  };

  const onActionPetProfileSubmit = async (
    event: any,
    ...args: Array<string | null>
  ) => {
    event.preventDefault();
    const actionType = args[0];
    const actionArg = args[1];
    const actionHasConfirmDialogStep = args[2];
    if (actionHasConfirmDialogStep === "NEEDS_CONFIRMATION") {
      // eslint-disable-next-line no-restricted-globals
      if (confirm(translate("are_you_sure_delete_pet_profile"))) {
        onActionPetProfileSubmit(event, actionType, actionArg);
      }
      return;
    } else if (actionType === "DELETE") {
      await deletePetProfile(pet?.kinshipPetId);
      navigate(`/pet-medical-records`);
    }
  };

  // List of keys that have a clickable interaction ex linking to external website
  const clickIndicators = ["pack_subscription_id"];

  return (
    <>
      {!pet && <Alert severity="error">Pet Not found</Alert>}
      <Typography variant="h2" component="h2" sx={{ fontWeight: "medium" }}>
        {translate("pet_info")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          mt: 2,
          p: 4,
          border: 1,
          borderColor: "gray",
          borderRadius: 5,
        }}
      >
        <Avatar src={pet?.profilePic} sx={{ width: 200, height: 200, mr: 2 }} />
        <List>
          <ListItem>
            {translate("pet_type")}: {pet?.petType}
          </ListItem>
          <ListItem>
            {translate("name")}: {pet?.petName}
          </ListItem>
          <ListItem>
            {translate("gender")}: {pet?.gender}
          </ListItem>
          <ListItem>
            {translate("age")}
            {`: ${pet?.age?.split("/")[0]} years ${
              pet?.age?.split("/")[1]
            } months`}
          </ListItem>
          <ListItem>
            {translate("adoption_date")}:{" "}
            {`${new Date(pet?.adoptionDate || "").toLocaleDateString()}`}
          </ListItem>
          <ListItem>
            {translate("spayed_neutered")}:{" "}
            {pet?.spayedOrNeutered ? "yes" : "no"}
          </ListItem>
          <ListItem>
            {translate("breed")}: {pet?.userSelectPrimaryBreed}
          </ListItem>
          <Button
            type="submit"
            variant="contained"
            onClick={event =>
              onActionPetProfileSubmit(
                event,
                "DELETE",
                pet?.petName || "",
                "NEEDS_CONFIRMATION"
              )
            }
          >
            {translate("delete_pet_profile")} <DeleteIcon />
          </Button>
        </List>
      </Box>
      <MedicalRecordView
        pet={{
          ...(pet as KinshipPetProfile),
          ownershipLocale: currentLocale,
          ownersProfileExtras: ownersProfileExtras,
          ownersProfile: ownersProfile,
        }}
        onActionVaccination={fetchPetDetails}
      />
      <Typography
        variant="h4"
        component="h4"
        sx={{ my: 5, fontWeight: "medium" }}
      >
        {translate("additional_pet_details")}
      </Typography>
      <TableContainer component={Paper} sx={{ maxWidth: 800 }}>
        <Table sx={{ minWidth: 650 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell align="left">{translate("attribute")}</TableCell>
              <TableCell align="left">{translate("value")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pet
              ? Object.entries(pet).map(([key, value]) => {
                  const clickAble = !!clickIndicators.find(
                    indicator => indicator === key && value
                  );
                  if (typeof value != "string" && typeof value != "boolean") {
                    value = JSON.stringify(value);
                  }
                  return (
                    <TableRow
                      key={key}
                      hover={clickAble}
                      onClick={
                        clickAble
                          ? event => handleClick(event, key, value as any)
                          : undefined
                      }
                      sx={{
                        "&:nth-of-type(odd)": {
                          backgroundColor: "#e6e6e6",
                        },
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell align="left">{key}</TableCell>
                      <TableCell align="left">
                        {`${value}`}
                        {clickAble ? <OpenInNewIcon /> : null}
                      </TableCell>
                    </TableRow>
                  );
                })
              : null}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
